import { Box, styled } from "@mui/material";
import { BaseConfig } from "./_components/base-config";
import { useFormik } from "formik";
import { baseConfigSchema } from "@/schemas/product.schema";

const SectionWrapper = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2, 3),
}));

const Configuration = () => {
  const configFormik = useFormik({
    initialValues: {
      visibility: true,
      minAmount: "",
      maxAmount: "",
      dailyLimit: "",
    },
    validationSchema: () => baseConfigSchema,
    onSubmit: (values) => {
      console.log(values);
    },
  });

  return (
    <Box>
      <SectionWrapper>
        <form onSubmit={configFormik.handleSubmit}>
          <BaseConfig formik={configFormik} isDisabled={false} />
        </form>
      </SectionWrapper>
    </Box>
  );
};

export default Configuration;
